import React, { createContext, useContext, useState } from 'react';

const RoleContext = createContext();

export const useRole = () => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
};

export const RoleProvider = ({ children }) => {
  const [role, setRole] = useState('student'); // 'student' or 'professor'

  const toggleRole = () => {
    setRole(prev => prev === 'student' ? 'professor' : 'student');
  };

  const isStudent = role === 'student';
  const isProfessor = role === 'professor';

  // User data based on role
  const userData = {
    student: {
      name: 'Carlos Mendoza',
      handle: '@carlos_estudiante',
      avatar: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=100&h=100&fit=crop&crop=face',
    },
    professor: {
      name: 'Dra. María González',
      handle: '@prof_gonzalez',
      avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=face',
    }
  };

  const currentUser = userData[role];

  return (
    <RoleContext.Provider value={{ 
      role, 
      setRole, 
      toggleRole, 
      isStudent, 
      isProfessor, 
      currentUser 
    }}>
      {children}
    </RoleContext.Provider>
  );
};

export default RoleContext;
